// tslint:disable:max-line-length

import React from 'react';

export const ChartGauge = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M8,4.5c-4.4,0-8,3.6-8,8h3.2c0-2.7,2.1-4.8,4.8-4.8c1.3,0,2.5,0.5,3.4,1.4l2.3-2.3C12.2,5.4,10.2,4.5,8,4.5z" />
      <path d="M11.4,9.1c0.9,0.9,1.4,2.1,1.4,3.4H16c0-2.2-0.9-4.2-2.3-5.7L11.4,9.1z" />
    </svg>
  );
};
